const SESSION_EXPIRED='lotto:session-expired';
function reportExpiredSession(target=window){target.dispatchEvent(new Event(SESSION_EXPIRED));}
module.exports={SESSION_EXPIRED,reportExpiredSession};
